import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=ecb3f71c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecb3f71c')) {
      api.createRecord('ecb3f71c', component.options)
    } else {
      api.reload('ecb3f71c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=ecb3f71c&", function () {
      api.rerender('ecb3f71c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cAgfCW9diOy4/JS/offershelp.vue"
export default component.exports